<template>
  <modal
    :name="name"
    :maxWidth="600"
    width="90%"
    height="auto"
    :adaptive="true"
    style="overflow: hidden"
  >
    <resource
      @resource-persisted="$modal.hide(name)"
      class="m-0"
      resource="transaction"
      resourceName="Manuelle Transaktion"
      :attributes="[
        {
          name: 'customer_profile_id',
          value: model.id,
          type: 'hidden'
        },
        {
          name: 'amount',
          placeholder:
            'Wie viele ' + currency + ' sollen gutgeschrieben werden?',
          type: 'InputSelector'
        },
        {
          name: 'price',
          placeholder: 'Wie viele € wurden für den Kauf bezahlt?',
          type: 'InputSelector'
        },
        {
          name: 'service',
          nullValue: 'Zu welcher Bezahlmethode soll dies verbucht werden?',
          type: 'DropdownSelector',
          items: options
        }
      ]"
    >
      <div slot="title">
        <h2>Zahlung für {{ model.name }} eintragen</h2>
      </div>
    </resource>
  </modal>
</template>
<script>
export default {
  data() {
    return {
      translatedServices: null,
      manualTransactionMethod:
        "Zu welcher Bezahlmethode soll dies verbucht werden?"
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    currency() {
      return Laravel.lang.currency;
    },
    options() {
      const translatedServices = this.$store.getters["transaction/options"](
        "translated-earning-services"
      );
      if (translatedServices === null) {
        return [];
      }
      return Object.keys(translatedServices).map(serviceKey => {
        return { value: serviceKey, text: translatedServices[serviceKey] };
      });
    }
  }
};
</script>
